function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 37.159,
    y1: 23.1011,
    x2: 184.629,
    y2: 157.161,
    gradientTransform: "matrix(1 0 0 -1 0 200)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D43C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A70095"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M197.56,185.77l-56.87-56.87c11.02-13.61,17.65-30.9,17.65-49.73 C158.33,35.52,122.82,0,79.17,0S0,35.52,0,79.17s35.52,79.17,79.17,79.17c18.83,0,36.12-6.63,49.73-17.65l56.87,56.87 c1.62,1.62,3.76,2.44,5.89,2.44s4.27-0.82,5.89-2.44c3.26-3.26,3.26-8.52,0-11.78L197.56,185.77z M79.17,141.67 c-34.47,0-62.5-28.03-62.5-62.5s28.03-62.5,62.5-62.5s62.5,28.03,62.5,62.5S113.64,141.67,79.17,141.67z"
  }));
};
export default SvgSearch;